module.exports = __webpack_public_path__ + "static/media/MomBuddhaMeditation.1a1f2850.jpg";